<div class="box">

    <h3 mat-dialog-title>Set Banner</h3>
    <div mat-dialog-content class="content">
        <span>Crop image to suitable size.</span>
        <!-- <div class="imgWrapper"> -->
            <!-- <img src="assets/images/dailog-box/warning.jpg " alt=""> -->
        <!-- </div> -->
        <image-cropper [imageChangedEvent]="data.imageChanged" [maintainAspectRatio]="true" [aspectRatio]="4.78 / 1"
            format="jpeg" (imageCropped)="imageCropped($event)" output="base64">
        </image-cropper>

        <!-- <span class="description" [innerHTML]="'Dummy Description'"></span> -->
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button class="Cancel" (click)="negativeAction()">Cancel</button>
        <button mat-raised-button class="Save" (click)="positiveAction()" (mouseover)="this.set = true"
            (mouseout)="this.set = false">Save</button>
    </div>
</div>
<div class="bg" [class.set]="set"></div>